export const PoemPOV = () => {
    return (
        <div id="010" className="">
            <p>observe me, maybe let's</p>
            <p>both be objects to look at,</p>
            <p>
                the planet continues pretending that it's not made out of
                plastic,
            </p>
            <p>cardboard blue sky paper diorama,</p>
            <p>spit in my mouth like in porn.</p>
            <p>the truth was always in plain sight -</p>
            <p>all my actions aim only to get in or out of its view,</p>
            <p>a good ratio of lying to being honest,</p>
            <p>when everything's a test score</p>
            <p>there must be a way to cheat as well,</p>
            <p>you said nothing makes sense,</p>
            <p>turns out your guess was right about half of the time,</p>
            <p>the world remains as it is,</p>
            <p>partially absurd, partially inhabited,</p>
            <p>
                some things are meaningless until meaning is painted onto them,
            </p>
            <p>some coincidences do turn out to be crazy conspiracies,</p>
            <p>and every now and then you're completely right</p>
            <p>to fear the things that you fear despite</p>
            <p>everyone else saying otherwise.</p>
            <br />
            <p>well maybe i can't put in the effort,</p>
            <p>but in life there's no better acquaintance</p>
            <p>that you can have than God Himself,</p>
            <p>and i've got His phone number,</p>
            <p>or at least i think i do, and that's what matters,</p>
            <p>not reality but the tint of the glasses,</p>
            <p>not the [out there] but the [in here],</p>
            <p>a dishonest life is just regular life,</p>
            <p>P.O.V. universe,</p>
            <p>billions of particles of light from the Sun</p>
            <p>come from millions of miles away to the Earth,</p>
            <p>crossing an infinite sea of vacuum,</p>
            <p>darting straight through the atmosphere</p>
            <p>to shine light in a room</p>
            <p>where you're clicking a checkbox on a screen,</p>
            <p>lying about your age on the internet.</p>
            <p>the world is what you make it, isn't it?</p>
        </div>
    );
};
